import React, { Component } from 'react';
import classNames from 'classnames';
import { Field } from 'formik';
import PropTypes from 'prop-types';

import applyFormTheme from './applyFormTheme';
import { formThemeShape } from './PropTypes';
import style from './Input.scss';

const TEXT = 'text';
const DATE = 'date';
const DATETIME_LOCAL = 'datetime-local';
const EMAIL = 'email';
const MONTH = 'month';
const NUMBER = 'number';
const PASSWORD = 'password';
const SEARCH = 'search';
const TEL = 'tel';
const TIME = 'time';
const URL = 'url';
const WEEK = 'week';

const TEXT_TYPES = [
  TEXT,
  DATE,
  DATETIME_LOCAL,
  EMAIL,
  MONTH,
  NUMBER,
  PASSWORD,
  SEARCH,
  TEL,
  TIME,
  URL,
  WEEK,
];

export default class Input extends Component {
  static propTypes = {
    id: PropTypes.string,
    name: PropTypes.string.isRequired,
    type: PropTypes.string,
    component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    className: PropTypes.string,
    multiline: PropTypes.bool,
    gray: PropTypes.bool,
    touched: PropTypes.bool,
    valid: PropTypes.bool,
  };

  static defaultProps = {
    type: 'text',
  };

  static contextTypes = {
    formTheme: formThemeShape,
    // eslint-disable-next-line react/forbid-prop-types
    formik: PropTypes.object,
  };

  setInputNode = (node) => {
    this.inputNode = node;
  };

  focus = () => {
    if (this.inputNode) {
      this.inputNode.focus();
    }
  };

  renderInput({ multiline, gray, touched, valid, className, component, ...props }) {
    const isTextarea = props.type === TEXT && multiline;
    const isText = TEXT_TYPES.indexOf(props.type) !== -1;
    if (component == null) {
      component = isTextarea ? 'textarea' : 'input';
    }
    return React.createElement(component, {
      ...props,
      className: classNames(
        style.input,
        isText && style['input--text'],
        isTextarea && style['input--multiline'],
        gray && style['input--gray'],
        {
          [style['input--success']]: touched && valid,
          [style['input--error']]: touched && !valid,
        },
        className
      ),
      id: props.id || props.name,
      ref: this.setInputNode,
    });
  }

  render() {
    const { formTheme, formik } = this.context;
    const { gray } = applyFormTheme(formTheme, this.props);
    if (!formik) {
      return this.renderInput({ ...this.props, gray });
    }
    return (
      <Field name={this.props.name}>
        {({ field, form }) => {
          const touched = form.touched && form.touched[field.name];
          const valid = form.errors == null || form.errors[field.name] == null;

          return this.renderInput({ touched, valid, ...field, ...this.props, gray });
        }}
      </Field>
    );
  }
}
